import * as React from 'react'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'

interface SeoProps {
  author?: '당근' | '당근페이' | 'Karrot'
  description?: string
  title?: string
  ogImage?: string
}

export const Seo = ({ author, description, title, ogImage }: SeoProps) => {
  const queryData = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          title
          description
        }
      }
    }
  `)
  const metaTitle = title || queryData.site?.siteMetadata?.title
  const metaDescription =
    description || queryData.site?.siteMetadata?.description
  const metaImage =
    ogImage || 'https://assetstorage.krrt.io/1163720620243824389/0e80c0d7-061c-4968-98bb-b73ed6e37619/width=1080,height=540.png'

  return (
    <Helmet>
      <title>{metaTitle}</title>
      <meta
        name="article:author"
        property="article:author"
        content={author || '당근'}
      />
      <meta
        name="description"
        property="description"
        content={metaDescription}
      />
      <meta
        name="og:description"
        property="og:description"
        content={metaDescription}
      />

      <meta name="og:image" property="og:image" content={metaImage} />
      <meta name="og:image:width" property="og:image:width" content="1200" />
      <meta name="og:image:height" property="og:image:height" content="630" />
      <meta name="og:type" content="article" />
      <meta name="twitter:card" content="article" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />
      <meta name="twitter:creator" content={author} />
    </Helmet>
  )
}
